import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let blank = {
    component: {
        render(c) {
            return c("router-view");
        }
    }
};

function configRoutes() {
    return [
        {
            path: "/",
            redirect: "/login",
            name: "Home",
            component: () => import("@/containers/DefaultContainer"),
            meta: { hideInBreadcrumb: true },
            children: [
                {
                    path: "dashboard",
                    name: "Dashboard",
                    component: () => import("@/views/Dashboard")
                },
                {
                    path: "tableau",
                    name: "Tableau",
                    component: () => import("@/views/Tableau")
                },
                {
                    path: "master",
                    name: "Master",
                    redirect: "/master/barang",
                    ...blank,
                    children: [
                        {
                            path: "aksesoris",
                            name: "Aksesoris",
                            component: () =>
                                import("@/views/master/aksesoris/ListAksesoris")
                        },
                        {
                            path: "barang",
                            name: "Barang",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/master/barang/ListBarang")
                                },
                                {
                                    path: ":segment/:id",
                                    name: "Edit Barang",
                                    component: () =>
                                        import("@/views/master/barang/EditBarang")
                                }
                            ]
                        },
                        {
                            path: "rumus-umum-grade",
                            name: "Rumus Umum Grade",
                            component: () =>
                                import("@/views/master/rumus-umum-grade/RumusUmumGrade")
                        },
                        {
                            path: "adjustment-harga-gudang",
                            name: "Adjustment Harga Gudang",
                            component: () =>
                                import("@/views/master/adjustment-harga-gudang/AdjustmentHargaGudang")
                        },
                        {
                            path: "adjustment-harga-batangan",
                            name: "Adjustment Harga Batangan",
                            component: () =>
                                import("@/views/master/adjustment-harga-batangan/AdjustmentHargaBatangan")
                        },
                        {
                            path: "kategori-kerusakan",
                            name: "Kategori Kerusakan",
                            component: () =>
                                import("@/views/master/kategori-kerusakan/KategoriKerusakan")
                        },
                        {
                            path: "adjustment-kerusakan",
                            name: "Adjustment Kerusakan",
                            component: () =>
                                import("@/views/master/adjustment-kerusakan/AdjustmentKerusakan")
                        },
                        {
                            path: "gudang",
                            name: "Gudang",
                            component: () =>
                                import("@/views/master/gudang/ListGudang")
                        },
                        {
                            path: "spek",
                            name: "Spek Barang",
                            component: () =>
                                import("@/views/master/spek/ListSpek")
                        },
                        {
                            path: "warna",
                            name: "Warna Barang",
                            component: () =>
                                import("@/views/master/warna/ListWarna")
                        },
                        {
                            path: "kategori-foto",
                            name: "Kategori Foto",
                            component: () =>
                                import("@/views/master/kategori-foto/KategoriFoto")
                        }
                    ]
                },
                {
                    path: "inventory",
                    name: "Inventory",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/inventory/ListInventory")
                        },
                        {
                            path: "edit/:id",
                            name: "Edit Inventory",
                            component: () =>
                                import("@/views/inventory/EditInventory")
                        }
                    ]
                },
                {
                    path: "pindah-gudang",
                    name: "Pindah Gudang",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/pindah-barang/ListPindahBarang")
                        },
                        {
                            path: "draft/:id",
                            name: "Draft Pindah Gudang",
                            component: () =>
                                import("@/views/pindah-barang/DraftPindahBarang")
                        },
                        {
                            path: ":id",
                            name: "Detail Pindah Gudang",
                            component: () =>
                                import("@/views/pindah-barang/DetailPindahBarang")
                        }
                    ]
                },
                {
                    path: "barang-masuk",
                    name: "Barang Masuk",
                    ...blank,
                    children: [
                        {
                            path: "list",
                            component: () =>
                                import("@/views/barang-masuk/ListPengiriman")
                        },
                        {
                            path: "input",
                            name: "Input Barang Masuk",
                            component: () =>
                                import("@/views/barang-masuk/InputBarangMasuk")
                        },
                        {
                            path: "approve",
                            name: "Approve Barang Masuk",
                            component: () =>
                                import("@/views/barang-masuk/ListPengiriman")
                        },
                        {
                            path: "upload",
                            name: "Upload Foto / Video",
                            component: () =>
                                import("@/views/barang-masuk/Upload")
                        },
                        {
                            path: "input-accesoris",
                            name: "Approve Aksesoris",
                            component: () =>
                                import("@/views/barang-masuk/InputAcc")
                        },
                        {
                            path: ":deliveryId",
                            name: "Batch Barang Masuk",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/barang-masuk/ListBatch")
                                },
                                {
                                    path: ":batchId",
                                    name: "List Barang",
                                    component: () =>
                                        import("@/views/barang-masuk/ListBarangMasuk")
                                }
                            ]
                        },

                    ]
                },
                {
                    path: "sales",
                    name: "Penjualan",
                    ...blank,
                    children: [
                        {
                            path: "customer",
                            name: "Customer",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/sales/customer/ListCustomer")
                                }
                                // {
                                //     path: 'payment/:id',
                                //     name: "Pembayaran Piutang Customer",
                                //     component: () => import('@/views/sales/customer/Payment')
                                // }
                            ]
                        },
                        {
                            path: "invoice",
                            name: "Invoice",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/sales/invoice/ListInvoice")
                                },
                                {
                                    path: "draft/:id",
                                    name: "Draft Invoice",
                                    component: () =>
                                        import("@/views/sales/invoice/DraftInvoice")
                                },
                                {
                                    path: "payments/:id",
                                    name: "Invoice Payments",
                                    component: () =>
                                        import("@/views/sales/invoice/PaymentInvoice")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Invoice",
                                    component: () =>
                                        import("@/views/sales/invoice/DetailInvoice")
                                }
                            ]
                        },
                        {
                            path: "retur",
                            name: "Daftar Retur",
                            component: () =>
                                import("@/views/sales/retur/ListRetur")
                        },
                        {
                            path: "transactions",
                            name: "Daftar Transaksi",
                            component: () =>
                                import("@/views/sales/transactions/ListTransaction")
                        },
                        {
                            path: "retur-request",
                            name: "Daftar Retur Request",
                            component: () =>
                                import("@/views/sales/retur-request/ListReturRequest")
                        },
                        {
                            path: "point-transactions",
                            name: "Daftar Transaksi Poin",
                            component: () =>
                                import("@/views/sales/point-transactions/ListPointTransaction")
                        }
                    ]
                },
                {
                    path: "adjustment-barcode",
                    name: "Adjustment Barcode",
                    component: () =>
                        import("@/views/adjustment-barcode/ListAdjustmentBarcode")
                },
                {
                    path: "log-barcode",
                    name: "Log Barcode",
                    component: () =>
                        import("@/views/log-barcode/ListLogBarcode")
                },
                {
                    path: "kirim-balik",
                    name: "Kirim Balik PGI",
                    ...blank,
                    children: [
                        {
                            path: "item",
                            name: "Return Item",
                            component: () =>
                                import("@/views/kirim-balik/ListKirimBalik")
                        },
                        {
                            path: "invoice",
                            name: "Invoice Pengembalian",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/kirim-balik/ListInvoiceKirimBalik")
                                },
                                {
                                    path: "draft/:id",
                                    component: () =>
                                        import("@/views/kirim-balik/DraftInvoiceKirimBalik")
                                },
                                {
                                    path: ":id",
                                    component: () =>
                                        import("@/views/kirim-balik/DetailInvoiceKirimBalik")
                                }
                            ]
                        },
                        {
                            path: "cancel-item",
                            name: "Cancel Return Item",
                            component: () =>
                                import("@/views/kirim-balik/ListCancelKirimBalik")
                        },
                        {
                            path: "cancel-invoice",
                            name: "Invoice Cancel Pengembalian",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/kirim-balik/ListInvoiceCancelKirimBalik")
                                },
                                {
                                    path: "draft/:id",
                                    component: () =>
                                        import("@/views/kirim-balik/DraftInvoiceCancelKirimBalik")
                                },
                                {
                                    path: ":id",
                                    component: () =>
                                        import("@/views/kirim-balik/DetailInvoiceCancelKirimBalik")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "inventory-reset",
                    name: "Inventory Reset",
                    component: () =>
                        import("@/views/inventory-reset/ListInventoryReset")
                },
                {
                    path: "inventory-report",
                    name: "Inventory Report",
                    component: () =>
                        import("@/views/inventory/ListInventoryReport")
                },
                {
                    path: "shopping-cart",
                    name: "Shopping Cart",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/shopping-cart/ListShoppingCart")
                        },
                        {
                            path: ":id",
                            name: "Detail Shopping Cart",
                            component: () =>
                                import("@/views/shopping-cart/DetailShoppingCart")
                        }
                    ]
                },
                {
                    path: "laporan",
                    name: "Laporan",
                    component: () => import("@/views/laporan/Laporan")
                },
                {
                    path: "admin",
                    name: "Administrasi",
                    ...blank,
                    children: [
                        {
                            path: "user",
                            name: "User",
                            component: () =>
                                import("@/views/administrasi/user/ListUser")
                        },
                        {
                            path: "role",
                            name: "Role",
                            component: () =>
                                import("@/views/administrasi/role/ListRole")
                        },
                        {
                            path: "divisi",
                            name: "Divisi",
                            component: () =>
                                import("@/views/administrasi/divisi/ListDivisi")
                        }
                    ]
                }
            ]
        },
        {
            path: "/login",
            name: "Login",
            component: () => import("@/views/Login")
        }
        // {
        //     // path: '/katalog/detail',
        //     path: '/katalog/:id',
        //     name: 'Detail Katalog',
        //     component: () => import('@/views/KatalogDetail')
        // },
        // {
        //     path: '/katalog',
        //     name: 'Katalog',
        //     component: () => import('@/views/Katalog')
        // }
    ];
}

export default new Router({
    mode: "history",
    linkActiveClass: "open active",
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
});
